import { loadScript } from './loadScript'

const YANDEX_MAPS_URL =
  'https://api-maps.yandex.ru/2.1/?apikey=895a52dd-e738-46b4-b66c-fde870b06c0c&lang=ru_RU'
// загрузчик карт тянет за собой ещё несколько файлов, поэтому ждём дольше
const TIMEOUT_MS = 10000

export const loadYandexMaps = (): Promise<void> =>
  loadScript(YANDEX_MAPS_URL, TIMEOUT_MS)
